import Header from "../../../components/Assessment/Header/Header";
import Footer from "../../../components/Footer/Footer";
import IntegrationAppList from "./IntegrationAppList/IntegrationAppList";
import { t } from "i18next";
import "./Integrations.scss";
import IntegrationAppDetails from "./IntegrationAppDetails/IntegrationAppDetails";
import { AssessmentButton } from "ui-components";
import { useEffect, useState } from "react";
import { setInQueryParams } from "../../../utils/Common/Constant";
import { getIntegrations } from "../../../service/Settings/Settings";
import { useNavigate } from "react-router-dom";

export default function Integration() {
  const [integrationModal, setIntegrationModal] = useState<boolean>(false);
  const [renderList, setRenderList] = useState(0);
  const [appList, setAppList] = useState<any>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  useEffect(() => {
    getAppList();
  }, [currentPage, pageSize, renderList]);
  const getAppList = async () => {
    setIsLoading(true);
    try {
      const getApp: any = await getIntegrations(currentPage, pageSize);
      if (getApp?.status === 200) {
        setTotalCount(getApp?.data?.totalCount);
        setAppList(getApp?.data?.data);
        if (getApp?.data?.data?.length > 0) {
          setInQueryParams(
            queryParams,
            "at",
            getApp?.data?.data[0]?.clientId,
            navigate,
          );
        }
      } else {
        setAppList([]);
      }
    } catch (error) {
      console.error("Failed to fetch apps:", error);
      setAppList([]);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Header />
      <div className="container-fluid integrationSidebarSec">
        <div className="row">
          <div className="col-md-12">
            <div className="skillsNameSec">
              <div className="profileHeader">
                <span className="name">{t("GENERAL.INTEGRATIONS")}</span>
                <AssessmentButton onClick={() => setIntegrationModal(true)}>
                  {t("SETTING.ADD_INTEGRATION")}
                </AssessmentButton>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-sm-12 col-md-3 col-lg-2">
            <div className="integrationSidebar">
              <div className="assessmentList">
                <IntegrationAppList
                  integrationModal={integrationModal}
                  setIntegrationModal={setIntegrationModal}
                  setRenderList={setRenderList}
                  appList={appList}
                  totalCount={totalCount}
                  isLoading={isLoading}
                  setCurrentPage={setCurrentPage}
                  setPageSize={setPageSize}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  getAppList={getAppList}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-9 col-lg-10">
            <div className="content-area">
              <IntegrationAppDetails getAppList={getAppList} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
